/* ============================================================
   MUSE DISC — Collection page JS
   ============================================================ */

(function () {
  // --- Sort form auto-submit --------------------------------
  const sortForm = document.querySelector('[data-sort-form]');
  if (sortForm) {
    sortForm.querySelector('select').addEventListener('change', () => sortForm.submit());
  }

  // --- Card staggered entrance via IntersectionObserver ----
  const cards = document.querySelectorAll('.coll-card');
  if (!cards.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const card = entry.target;
      const idx  = parseInt(card.dataset.index, 10) || 1;
      setTimeout(() => card.classList.add('is-visible'), (idx - 1) * 60);
      io.unobserve(card);
    });
  }, { threshold: 0.1 });

  cards.forEach(card => io.observe(card));
})();
